import { render, staticRenderFns } from "./ConsignStockByCustomer.vue?vue&type=template&id=45cb53e2&scoped=true&"
import script from "./ConsignStockByCustomer.vue?vue&type=script&lang=js&"
export * from "./ConsignStockByCustomer.vue?vue&type=script&lang=js&"
import style0 from "./ConsignStockByCustomer.vue?vue&type=style&index=0&id=45cb53e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cb53e2",
  null
  
)

export default component.exports